import { version } from './version';
import { CastoramaEnvironment } from './ciam-config';

const baseUrl = '#{base_url}#';
const backendBaseUrl = '#{backend_url}#';

export const createCustomerEnvironment = (authAppBaseUrl: string): CastoramaEnvironment => ({
  production: true,
  application: {
    baseUrl,
    name: 'CastoramaFidelite',
    logoUrl: '',
  },
  apis: {
    default: {
      url: backendBaseUrl,
      rootNamespace: 'CastoramaFidelite',
    },
    captainWallet: {
      url: '#{captainwallet_url}#',
      campaignId: 'loyalty',
      channel: 'web'
    }
  },
  googleTagManager: {
    tag: '#{gtm_id}#'
  },
  links: {
    cguUrl: '#{cgu_url}#',
    cgvUrl: '#{cgv_url}#',
  },
  ciam: {
    enabled: true,
    authAppBaseUrl,
    callbackPath: '/auth/callback',
    signInPath: '/signin',
    registerPath: '/register',
    activationPath: '/activation',
    forgotPasswordPath: '/forgot-password',
    bff: {
      baseUrl: backendBaseUrl,
      exchangePath: '/api/app/ciam/exchange',
      refreshPath: '/api/app/ciam/refresh',
      logoutPath: '/api/app/ciam/session',
      customerPath: '/api/app/ciam/customer',
    },
  },
  version
});
